/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { UpdateTagDetailsRequest } from './updateTagDetailsRequest';

export interface UpdateTagRequest { 
    value: string;
    colorCode: string;
    screenshot: boolean;
    translate: boolean;
    langs: Array<UpdateTagRequest.LangsEnum>;
    details: Array<UpdateTagDetailsRequest>;
    categoryId: string;
}
export namespace UpdateTagRequest {
    export type LangsEnum = 'MK' | 'EN' | 'AL';
    export const LangsEnum = {
        MK: 'MK' as LangsEnum,
        EN: 'EN' as LangsEnum,
        AL: 'AL' as LangsEnum
    };
}